module.exports = __webpack_public_path__ + "static/media/bnote.f587147d.svg";